var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { attrs: { title: "Gestión de usuarios", "title-color": "primary" } },
        [
          _c(
            "vs-table",
            {
              attrs: {
                data: _vm.usuarios,
                search: true,
                pagination: true,
                maxItems: 10,
                noDataText: "Sin registros encontrados"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var data = ref.data
                    return _vm._l(data, function(tr, indextr) {
                      return _c(
                        "vs-tr",
                        { key: indextr, attrs: { "data-cy": "user" } },
                        [
                          _c("vs-td", { attrs: { data: data[indextr].iut } }, [
                            _vm._v(" " + _vm._s(data[indextr].iut) + " ")
                          ]),
                          _c(
                            "vs-td",
                            { attrs: { data: data[indextr].nombre } },
                            [_vm._v(" " + _vm._s(data[indextr].nombre) + " ")]
                          ),
                          _c(
                            "vs-td",
                            { attrs: { data: data[indextr].correo } },
                            [_vm._v(" " + _vm._s(data[indextr].correo) + " ")]
                          ),
                          _c("vs-td", { attrs: { data: data[indextr].id } }, [
                            _c(
                              "div",
                              {
                                staticClass: "btn-group",
                                attrs: { size: "small", role: "group" }
                              },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    attrs: {
                                      size: "small",
                                      color: "primary",
                                      "data-cy": "edit-user"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.editarUsuario(tr)
                                      }
                                    }
                                  },
                                  [_vm._v("Editar")]
                                ),
                                _c(
                                  "vs-button",
                                  {
                                    attrs: {
                                      size: "small",
                                      color: "dark",
                                      "data-cy": "delete-user"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.eliminarUsuario(tr)
                                      }
                                    }
                                  },
                                  [_vm._v("Eliminar")]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    })
                  }
                }
              ])
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "vs-button",
                    {
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: { size: "small" },
                      on: { click: _vm.agregarUsuario }
                    },
                    [_vm._v(" Agregar ")]
                  )
                ],
                1
              ),
              _c(
                "template",
                { slot: "thead" },
                [
                  _c("vs-th", [_vm._v("RUT")]),
                  _c("vs-th", [_vm._v("Nombre")]),
                  _c("vs-th", [_vm._v("Correo")]),
                  _c("vs-th", [_vm._v("Acciones")])
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _c("modal-usuario", {
        attrs: { editar: _vm.editar, usuario: _vm.usuario },
        on: { cerrarEdicionUsuario: _vm.cancelarEdicion }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }